var map = {
	"./assets/KStudioHoriz.svg": "6084",
	"./assets/OlympicsLogo.svg": "3f30",
	"./assets/OlympicsLogoText.svg": "843d",
	"./assets/casters_icon.svg": "57d1",
	"./assets/casttypes/illustrations/AudioMultiTrack.svg": "0d79",
	"./assets/casttypes/illustrations/FanRoom.svg": "514e",
	"./assets/casttypes/illustrations/Plain.svg": "af4d",
	"./assets/casttypes/illustrations/Recorder.svg": "c8e2",
	"./assets/casttypes/illustrations/StationSwitcher.svg": "04723",
	"./assets/casttypes/illustrations/Switcher.svg": "805d",
	"./assets/cc-logo-beta.svg": "c845",
	"./assets/cc-logo.svg": "f849",
	"./assets/chat_bubble.svg": "b1b1",
	"./assets/chat_icon.svg": "83fb",
	"./assets/headphones_icon.svg": "8b0b",
	"./assets/i_o_icon.svg": "8f0c",
	"./assets/icons/AudioMultiTrack.svg": "3057",
	"./assets/icons/Clips.svg": "ccd8",
	"./assets/icons/FanRoom.svg": "dfa7",
	"./assets/icons/Graphics.svg": "03d6",
	"./assets/icons/LiveStreams.svg": "7204",
	"./assets/icons/Plain.svg": "3f9b",
	"./assets/icons/Recorder.svg": "9cb9",
	"./assets/icons/Replay.svg": "7c79",
	"./assets/icons/Switcher.svg": "7ce9",
	"./assets/icons/Websource.svg": "2320",
	"./assets/icons/add-user.svg": "2837",
	"./assets/icons/all.svg": "e795",
	"./assets/icons/arrow.svg": "21e2",
	"./assets/icons/assets.svg": "35bf",
	"./assets/icons/audio-panel.svg": "2366",
	"./assets/icons/audiomix.svg": "749f",
	"./assets/icons/bars.svg": "cbd5",
	"./assets/icons/billing.svg": "e15b",
	"./assets/icons/broken-screen.svg": "204f",
	"./assets/icons/calendar.svg": "b8bd",
	"./assets/icons/caret-left.svg": "eee7",
	"./assets/icons/caret-right.svg": "138f",
	"./assets/icons/channel.svg": "923d",
	"./assets/icons/chat.svg": "9b69",
	"./assets/icons/check.svg": "7bae",
	"./assets/icons/cheer.svg": "071c",
	"./assets/icons/chrome.svg": "b5dd",
	"./assets/icons/clip.svg": "9d0f",
	"./assets/icons/clipper.svg": "3243",
	"./assets/icons/clock.svg": "755b",
	"./assets/icons/close.svg": "8b1b",
	"./assets/icons/cloud-up.svg": "ebc2",
	"./assets/icons/color-palette.svg": "ebf0",
	"./assets/icons/copy-filled.svg": "76f2",
	"./assets/icons/crew.svg": "fb0c",
	"./assets/icons/csv.svg": "3ce7",
	"./assets/icons/cue-in.svg": "db46",
	"./assets/icons/delete-filled.svg": "a3c9",
	"./assets/icons/delete.svg": "0d45",
	"./assets/icons/dot-arrow-up.svg": "2c1c",
	"./assets/icons/download.svg": "f28e",
	"./assets/icons/drag.svg": "88c6",
	"./assets/icons/dropdown-caret.svg": "30b6",
	"./assets/icons/edge.svg": "343ef",
	"./assets/icons/edit.svg": "daf0",
	"./assets/icons/events.svg": "dbf8",
	"./assets/icons/export-csv.svg": "394c",
	"./assets/icons/eye-caret-down.svg": "42e4",
	"./assets/icons/eye-caret-up.svg": "7d76",
	"./assets/icons/eye.svg": "7364",
	"./assets/icons/fan-polls.svg": "4bb2",
	"./assets/icons/fire.svg": "62e5",
	"./assets/icons/firefox.svg": "9920",
	"./assets/icons/flags/en.svg": "90e4",
	"./assets/icons/flags/es.svg": "f35d",
	"./assets/icons/flags/fr.svg": "26da",
	"./assets/icons/flags/it.svg": "8fb1",
	"./assets/icons/flags/ja.svg": "bed3",
	"./assets/icons/flags/ko.svg": "5d14",
	"./assets/icons/flags/pt.svg": "1605",
	"./assets/icons/flags/ru.svg": "4c2a",
	"./assets/icons/flags/zh.svg": "d6e4",
	"./assets/icons/full-screen.svg": "76af",
	"./assets/icons/globe.svg": "0de3",
	"./assets/icons/grid-panel.svg": "23a1",
	"./assets/icons/grid.svg": "4b05",
	"./assets/icons/guest-guide-avoid.svg": "9afd",
	"./assets/icons/guest-guide-express.svg": "49e3",
	"./assets/icons/guest-guide-position.svg": "3d54",
	"./assets/icons/hairpin.svg": "64fc",
	"./assets/icons/headphone-mic.svg": "dea4",
	"./assets/icons/headphone.svg": "d83e",
	"./assets/icons/health.svg": "d4c8",
	"./assets/icons/info.svg": "76ed",
	"./assets/icons/information.svg": "e923",
	"./assets/icons/layers.svg": "626a",
	"./assets/icons/layout.svg": "be29",
	"./assets/icons/link-rounded.svg": "a31c",
	"./assets/icons/link.svg": "40a1",
	"./assets/icons/loading.svg": "1e31",
	"./assets/icons/mail.svg": "3ae9",
	"./assets/icons/mark-replay.svg": "a669",
	"./assets/icons/microphone-slash.svg": "b702",
	"./assets/icons/minus.svg": "3e24",
	"./assets/icons/moments.svg": "c04e",
	"./assets/icons/muted.svg": "02df",
	"./assets/icons/olympic-flame.svg": "6435",
	"./assets/icons/on-air.svg": "26d1",
	"./assets/icons/ops.svg": "d425",
	"./assets/icons/pause.svg": "644b",
	"./assets/icons/pc.svg": "424f",
	"./assets/icons/pencil.svg": "e51f",
	"./assets/icons/pin.svg": "862b",
	"./assets/icons/pipette.svg": "cfad",
	"./assets/icons/plus.svg": "eb38",
	"./assets/icons/power-off.svg": "a810",
	"./assets/icons/profile.svg": "95dc",
	"./assets/icons/record.svg": "161c",
	"./assets/icons/refresh.svg": "53fa",
	"./assets/icons/requests.svg": "1c19",
	"./assets/icons/restart.svg": "48ae",
	"./assets/icons/rocket.svg": "6f49",
	"./assets/icons/rotate-phone.svg": "f88e",
	"./assets/icons/rotate.svg": "f109",
	"./assets/icons/safari.svg": "395d",
	"./assets/icons/save.svg": "9344",
	"./assets/icons/scenes.svg": "1e95",
	"./assets/icons/search.svg": "d103",
	"./assets/icons/server-2.svg": "2e17",
	"./assets/icons/server.svg": "90f6",
	"./assets/icons/settings.svg": "9174",
	"./assets/icons/sound.svg": "e245",
	"./assets/icons/stack-square.svg": "2ebf",
	"./assets/icons/station.svg": "cfc3",
	"./assets/icons/stats.svg": "5c7e",
	"./assets/icons/stop.svg": "56b4",
	"./assets/icons/streams-square.svg": "9551",
	"./assets/icons/streams.svg": "d02d",
	"./assets/icons/subwoofer.svg": "2780",
	"./assets/icons/teams.svg": "995c",
	"./assets/icons/teamview.svg": "3c56",
	"./assets/icons/templates.svg": "e5b9",
	"./assets/icons/trash.svg": "af22",
	"./assets/icons/twitter.svg": "acf9",
	"./assets/icons/upload.svg": "5a96",
	"./assets/icons/user-circle.svg": "deae",
	"./assets/icons/user-delete.svg": "b617",
	"./assets/icons/user-star.svg": "e840",
	"./assets/icons/video.svg": "512b",
	"./assets/icons/warning.svg": "daa9",
	"./assets/icons/x-plus.svg": "4fdd",
	"./assets/icons/x.svg": "7387",
	"./assets/icons/xmark.svg": "dc66",
	"./assets/kiswe-logo-name.svg": "93c8",
	"./assets/kiswe-logo-red.svg": "61d5",
	"./assets/person1.svg": "946f",
	"./assets/person2.svg": "ebab",
	"./assets/person3.svg": "7d01",
	"./assets/person4.svg": "6df0",
	"./assets/replay-thumbnail.svg": "e600",
	"./assets/settings.svg": "e9b0",
	"./assets/vu-scale-vertical.svg": "c64d",
	"./assets/webcam_icon.svg": "938b",
	"./assets/widget.svg": "666d",
	"./components/VueBeautifulChat/assets/chat-icon.svg": "0b1e",
	"./components/VueBeautifulChat/assets/close.svg": "019a",
	"./components/VueBeautifulChat/assets/file.svg": "f2c5",
	"./components/VueBeautifulChat/assets/logo-no-bg.svg": "3e61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa53";